define('ordersMailsUtils',[
  'app',
  'module',
  'backbone',
  'underscore',
  'settings',
  'ordersConfirmationView',
  'modalsConfirmationView',
  'ordersDetailInvoicesProformatPreviewView',
  'ordersDetailInvoicesNewView',
  'emailView',
  'modalsAlertView',
  'dateUtils',
  'ordersOrderUtils',
  'rolesMixin',
  'sparkmd5',
  'entities/mails',
  'entities/customers/customers',
  'entities/orders'
], function (
  App,
  module,
  Backbone,
  _,
  Settings,
  OrderConfirmationView,
  ConfirmationView,
  ProformatPreviewView,
  NewInvoiceView,
  EmailView,
  AlertView,
  DateUtils,
  OrderUtils, 
  RolesMixin,
  SparkMD5
) {
  'use strict';

  module.exports = {
    check: function(models, params) {
      var defer = $.Deferred();
      var methods = [];

      if(params && params.checkList) {
        _.each(params.checkList, _.bind(function(method) {
          if (method === 'max-colors')
            methods.push(this.checkOrderMaxColor);
          if (method === 'test2')
            methods.push(this.checkTest2);
          }, this));
      }

      this.applyCheckList(methods, models).done(_.bind(function() {
        defer.resolve();
        console.log('all promises resolved');
      }, this)).fail(_.bind(function() {
        defer.reject();
        console.log('some promises failed');
      }, this)).always(_.bind(function() {
        console.log('all promises completed');
      }, this));
      return defer.promise();
    },

    applyCheckList: function(methods, models) {
      var defer = $.Deferred();

      if(!methods || methods.length === 0) {
        defer.resolve();
      } else {
        var promise = methods[0];
        promise(models).done(_.bind(function () {
          methods.splice(0, 1);
          this.applyCheckList(methods, models).done(_.bind(function () {
            defer.resolve();
          }, this)).fail(_.bind(function () {
            defer.reject();
          }, this));
        }, this)).fail(_.bind(function () {
          defer.reject();
        }, this));
      }

      return defer.promise();
    },

    checkOrderMaxColor: function(models) {
      var defer = $.Deferred();
      var errorModels = [];

      errorModels = [];
      _.each(models, function (model) {
        if (model.hasTooManyColors()) {
          errorModels.push(model);
        }
      }, this);

      if (errorModels.length > 0) {
        OrderConfirmationView.prototype.open(
          _.i18n('orders.max-colors-error-modal.title'),
          errorModels,
          _.bind(function () {
            defer.resolve();
          }, this),
          _.bind(function () {
            defer.reject();
          }, this)
        );
      } else
        defer.resolve();

      return defer.promise();
    },

    checkTest2: function (models) {
      var defer = $.Deferred();
      OrderConfirmationView.prototype.open(
        'TEST2',
        models,
        _.bind(function () {
          defer.resolve();
        }, this),
        _.bind(function () {
          defer.reject();
        }, this)
      );
      return defer.promise();
    },

    getHistory: function (order, activated) {
      var defer = $.Deferred();
      var content = '';

      if (Settings.get('cAccountRoles')[RolesMixin.DASHBOARD_ORDERS_MAILS] &&
      !Settings.configValue('advancedMode') && activated) {
        $.ajax({
          type: 'GET',
          url: order.getMailsUrl({pageSize: 3, first: 0}),
          success: _.bind(function (previousEmails) {
            if (previousEmails && previousEmails.length > 0) {
              content = '<br><br><br>';
              content += DateUtils.toMDYHHMMFormat(previousEmails[0].sentDate);
              content += ' &lt;' + previousEmails[0].from[0].address + '&gt; wrote:<br><br>';
              content += previousEmails[0].content;
            }

            defer.resolve(content);
          }, this)
        });
      } else
        defer.resolve('');

      return defer.promise();
    },

    getOrderHash: function (userId, address, supplier) {
      var data = '';

      if (userId)
        data += userId;

      if (address) {
        data += address.addressL1 || '';
        data += address.addressL2 || '';
        data += address.city || '';
        data += address.countryCode || '';
        data += address.firstName || '';
        data += address.houseNumber || '';
        data += address.lastName || '';
        data += address.name || '';
        data += address.zip || '';
      }

      if (supplier)
        data += supplier.secId || '';
            
      return SparkMD5.hash(data);
    },

    getGroups: function (orders, checkAddress, checkSupplier) {
      var groups = [];
      _.each(orders, _.bind(function (order) {
        var group = null;
        _.each(groups, _.bind(function (g) { 
          var groupAddress = null;
          var orderAddress = null;
          if (checkAddress) {
            groupAddress = g.refDeliveryAddress;
            orderAddress = order.get('refDeliveryAddress');
          }    

          var groupSupplier = null;
          var orderSupplier = null;
          if (checkSupplier) {
            groupSupplier = g.supplier;
            orderSupplier = order.get('supplier');
          }

          var groupAddressHash = this.getOrderHash(g.userId, groupAddress, groupSupplier);
          var orderAddressHash = this.getOrderHash(order.get('endUserId'), orderAddress, orderSupplier);
          
          if (groupAddressHash === orderAddressHash)
            group = g;
        }, this));
      
        if (group === null) {
          group = {
            userId: order.get('endUserId'),
            refDeliveryAddress: order.get('refDeliveryAddress'),
            orders: new Backbone.Collection(),
            supplier: order.get('supplier')
          };
          groups.push(group);
        }

        group.orders.push(order);
      }, this));

      return groups;
    },  

    getFrom: function (template, locale) {    
      var from = '';

      var config = Settings.configValue('mails.standard');
      if (config && config.from && config.from.def)
        from = config.from.def;

      if (!template)
        return from;

      var configTemplate = null;
      _.each(Settings.configValue('mails.templates'), function (t) {
        if (t.template === template) {
          configTemplate = t;
        }
      }, this);
     
      if (configTemplate && configTemplate.from && configTemplate.from.def)
        from = configTemplate.from.def;

      if (configTemplate && configTemplate.from && configTemplate.from[locale.toLowerCase()]) 
        from = configTemplate.from[locale.toLowerCase()];        
     
      return from;     
    },    
    
    checkFrom: function (from) {
      var defer = $.Deferred();
      if (!from) {        
        defer.resolve();
      } else {
        var found = false;
       
        App.request('mails:getFromMails').done(_.bind(function (mails) {
          found = false;
          _.each(mails, _.bind(function (mail) {
            if (mail.email === from)
              found = true;
          }, this));

          if (found)
            defer.resolve();
          else
            defer.reject();
        }, this));       
      }

      return defer.promise();
    },    
     
    sendMail: function (orders, configTemplate, sentCallback, params) {
      try {
        var template = 'MAIL_SIGN';
        var excludeAttachment = false;
        var allowFromSelection = false;
        var viewTitle = '';        

        if(configTemplate) {       
          template = configTemplate.template; 

          if(configTemplate.excludeAttachment)
            excludeAttachment = configTemplate.excludeAttachment;

          if(configTemplate.allowFromSelection)
            allowFromSelection = configTemplate.allowFromSelection;  

          if(template)
            viewTitle = _.i18n('mails.template.' + template);
        }                 
        
        if (template === 'MAIL_ORDER_SUPPLIER' || template === 'MAIL_ORDER_SUPPLIER_REQUEST') {
          this.sendSupplierMail(orders, configTemplate, params);
          return;
        }

        if (template === 'MAIL_ORDER_INVOICE') {
          _.each(orders, _.bind(function (order) {  
            var endUser = App.request('customers:entity:end-user-id', order.get('endUserId'));
            endUser.fetch().done(_.bind(function () {

              $.ajax({
                type: 'GET',
                url: order.getInvoicesUrl({pageSize: 1000, first: 0}),
                success: _.bind(function (items) {
                  var invoices = [];
                  _.each(items, _.bind(function(item) {
                    var invoice = App.request('endUserInvoice:model', item);
                    if(invoice.get('invoiceType') === 'invoice' && !invoice.get('refCreditNote')) {
                      invoices.push(invoice);
                    }
                  }, this));

                  if(invoices.length > 0) {                    
                    this.sendInvoiceMail(endUser, invoices,
                    order.get('payedByCustomer'), _.bind(function () {
                      _.each(invoices, function (invoice) {
                        invoice.fetch();
                      }, this);
                    }, this));                    
                  }
                }, this)
              });             
            }, this));
          }, this));
          return;
        } 

        //-------------------------
        var groups = this.getGroups(orders, false, false); 

        //-------------------------
        _.each(groups, _.bind(function (group) {
          var customer = App.request('customers:entity:end-user-id', group.userId);
          customer.fetch().done(_.bind(function () {            
            var pois = [];
            _.each(group.orders.models, function (order) {
                pois.push(order.get('purchaseOrderId'));
            }, this);

            //------
            var locale = 'FR';
            if (Settings.configValue('customerDefaultMailLanguage'))
              locale = Settings.configValue('customerDefaultMailLanguage');

            if (customer.get('locales'))
              locale = customer.get('locales');

            //------
            var attachments = []; 
            var proofsheets = [];       

            if(excludeAttachment === false) {
              if(template === 'MAIL_PROFORMAT_SENT') {
                attachments.push({
                  url: Settings.url('dl', 'proforma', {
                      pois: pois.join(','),
                      v: Settings.configValue('advancedMode')?'2':'1'
                  }),
                  name: pois.join('-') + '.pdf',
                  'content-type': 'application/pdf'
                });
              } else if(template === 'MAIL_NEW_ORDER_NO_BAT') {
                var paid = true;
                _.each(group.orders.models, _.bind(function (order) {
                  if(order.get('payedByCustomer') === false)
                    paid = false;

                  var proofsheetUrl = OrderUtils.getProofSheetUrl(order, customer, true, false);                 
                  proofsheets.push({
                    url: proofsheetUrl,
                    poi: order.get('purchaseOrderId'),
                    productName: order.getProductName()
                  });

                  var pdfProofsheetUrl = OrderUtils.getProofSheetUrl(order, customer, true, true);      
                  var printUrl = Settings.url('x2Ws', 'pdf', {
                    param: btoa(pdfProofsheetUrl)
                  });
                  attachments.push({
                    url: printUrl,
                    name: order.getProofsheetFilename(customer) + '.pdf',
                    'content-type': 'application/pdf'
                  });  
                }, this));

                if(!paid) {
                  attachments.push({
                    url: Settings.url('dl', 'proforma', {
                        pois: pois.join(','),
                        v: Settings.configValue('advancedMode')?'2':'1'
                    }),
                    name: pois.join('-') + '.pdf',
                    'content-type': 'application/pdf'
                  });
                }            
              } else {              
                _.each(group.orders.models, _.bind(function (order) {
                  var proofsheetUrl = OrderUtils.getProofSheetUrl(order, customer, true, false);                 
                  proofsheets.push({
                    url: proofsheetUrl,
                    poi: order.get('purchaseOrderId'),
                    productName: order.getProductName()
                  });
                 
                  var pdfProofsheetUrl = OrderUtils.getProofSheetUrl(order, customer, true, true);      
                  var printUrl = Settings.url('x2Ws', 'pdf', {
                    param: btoa(pdfProofsheetUrl)
                  });
                  attachments.push({
                    url: printUrl,
                    name: order.getProofsheetFilename(customer) + '.pdf',
                    'content-type': 'application/pdf'
                  });                 
                }, this));
              }
            }
           
            //------
            var from = this.getFrom(template, locale);
            this.checkFrom(from).done(_.bind(function () {            
              EmailView.prototype.open({
                from: from,
                to: customer.get('email') || customer.get('endUserId'),
                allowFromSelection: allowFromSelection,              
                templateType: template,              
                fetchTemplateData: _.bind(function (type) {
                  var defer = $.Deferred();    
                  var data = {};

                  if(type === 'MAIL_ORDER_TRACKING') {
                     data.trackings = [];
                    _.each(group.orders.models, _.bind(function (order) {
                      if(order.get('trackings')) {
                        _.each(order.get('trackings'), function (tracking) {
                          var model = App.request('tracking-tab:new-model', tracking);

                          if (model.get('destinationType') === 'tocustomer') {
                            model.set('poi', order.get('poi'));
                            model.set('trackingUrl', model.trackingUrl(customer));
                            model.set('productName', order.getProductName());
                            data.trackings.push(model.toJSON());
                          }
                        }, this);
                      }
                    }, this));
                  }

                  data.proofsheets = proofsheets;
                  data.customer = customer.toJSON();
                 
                  defer.resolve(data);
                  return defer.promise();
                }, this),
                templateLocale: locale,
                attachments: attachments,
                title: viewTitle + ' | ' + pois.join(', '),
                id: viewTitle + pois.join(','),
                orders: group.orders,
                onMailSend: _.bind(function (mails) {
                  if (template === 'MAIL_ORDER_TRACKING') {
                    _.each(group.orders.models, function (order) {
                      _.each(order.get('trackings'), function (tracking) {
                        var model = App.request('tracking-tab:new-model', tracking);
                        model.set('sentDate', new Date(), {silent: true});
                        model.set('sentEmail', mails, {silent: true});
                        model.unset('refCommandLine');
                        model.save(order.get('purchaseOrderId'));                       
                      }, this);
                    }, this);
                  }          
                  
                  if (sentCallback)
                    sentCallback(mails);
                }, this)
              });
            }, this)).fail(_.bind(function () {
              AlertView.prototype.open('', _.i18n('common.googleFromEmailError').replace('%s', from));
            }, this));           
          }, this));

        }, this));

      } catch (err) {
        console.log(err);
      }
    },

    sendSupplierMail: function (orders, configTemplate, params) {
      try {
        var groups = this.getGroups(orders, true, true);    

        var allowFromSelection = false;
        var template = '';
        var excludeAttachment = false;
        var orderByEmail = false;

        if (configTemplate && configTemplate.allowFromSelection) {
          if(configTemplate.allowFromSelection)
            allowFromSelection = configTemplate.allowFromSelection;
          if(configTemplate.template)
            template = configTemplate.template;
          if(configTemplate.excludeAttachment)
            excludeAttachment = configTemplate.excludeAttachment;          
        }

        if(params) {
          if(params.orderByEmail === true)
            orderByEmail = true;
        }

        //-------------------------       
        _.each(groups, _.bind(function (group) {
          var customer = App.request('customers:entity:end-user-id', group.userId);
          customer.fetch().done(_.bind(function () {
            var locale = 'FR';
            var pois = [];

            _.each(group.orders.models, function (order) {
                pois.push(order.get('purchaseOrderId'));
            }, this);

            if (Settings.configValue('customerDefaultMailLanguage'))
              locale = Settings.configValue('customerDefaultMailLanguage');

            var attachments = [];   
            if(excludeAttachment === false) {                          
              _.each(group.orders.models, _.bind(function (order) {
                if (order.get('proofsheetFileUid')) {
                  attachments.push({
                    url: Settings.url('file', order.get('proofsheetFileUid')),
                    name: 'Printproof.pdf',
                    'content-type': 'application/pdf'
                  });
                }

                attachments.push({
                  url: order.getDeliveryFileUrl(pois, customer),
                  name: order.getDeliveryFileName(pois, customer),
                  'content-type': 'application/pdf'
                });

                if(order.get('compositions')) {
                  _.each(order.get('compositions'), function (composition) {
                    try {
                      if (composition.exportFileUid) {
                        attachments.push({
                          url: Settings.url('file', composition.exportFileUid),
                          name: 'Custom export file: ' + composition.paCode + ' - ' + composition.paName + '.pdf',
                          'content-type': 'application/pdf'
                        });
                      }
                    } catch (err) {
                      console.log(err);
                    }
                  });
                }    

                try {
                  var productionSheetUrl = Settings.url('pdf', '', {
                    poi: order.get('purchaseOrderId'),
                    docType: 'prs'
                  }, true);
                  
                  attachments.push({
                    url: productionSheetUrl,
                    name: 'Production sheet.pdf',
                    'content-type': 'application/pdf'
                  });      
                } catch (err) {
                  console.log(err);
                }                      

                _.each(order.get('attachments'), function (attachment) {
                  if (attachment.flag) {
                    var contentType = '*';
                    if(attachment.fileName.indexOf('.pdf') !== -1)
                      contentType = 'application/pdf';
                    if(attachment.fileName.indexOf('.png') !== -1)
                      contentType = 'image/png';
                    if(attachment.fileName.indexOf('.jpg') !== -1)
                      contentType = 'image/jpg';
                    if(attachment.fileName.indexOf('.jpeg') !== -1)
                      contentType = 'image/jpeg';
                    if(attachment.fileName.indexOf('.gif') !== -1)
                      contentType = 'image/gif';
                    if(attachment.fileName.indexOf('.bmp') !== -1)
                      contentType = 'image/bmp';
                    if(attachment.fileName.indexOf('.tiff') !== -1)
                      contentType = 'image/tiff';
                    if(attachment.fileName.indexOf('.tif') !== -1)
                      contentType = 'image/tiff';
                    if(attachment.fileName.indexOf('.doc') !== -1)
                      contentType = 'application/msword';

                    attachments.push({
                      url: Settings.url('file', attachment.fileUid),
                      name: attachment.fileName,
                      'content-type': contentType
                    });
                  }
                });
              }, this));
            }

            App.request('caccounts:get-share-from-sorted').done(_.bind(function (suppliers) {
              var supplier = _.find(suppliers, function (supplier) {
                return supplier.caccountFrom.secId === group.supplier.secId;
              });             

              if ((supplier && supplier.orderEmail && supplier.orderByEmail) || orderByEmail) {
                if(supplier.caccountFrom && supplier.caccountFrom.language) {
                    locale = supplier.caccountFrom.language;
                }
                var localeFrom = locale;
                if (configTemplate.template === 'MAIL_ORDER_SUPPLIER_REQUEST' && customer.get('locales')) {
                    localeFrom = customer.get('locales');
                }
                //----------
                var from = this.getFrom(template, localeFrom);
                this.checkFrom(from).done(_.bind(function () {
                  EmailView.prototype.open({
                    from: from,
                    to: supplier.orderEmail,
                    allowFromSelection: allowFromSelection,                   
                    templateType: template,                   
                    fetchTemplateData: _.bind(function () {
                      var defer = $.Deferred();    
                      defer.resolve({
                        supplier: supplier,
                        deliveryAddress: group.refDeliveryAddress,
                        customer: customer.toJSON()
                      });
                      return defer.promise();
                    }, this),                  
                    templateLocale: locale,
                    attachments: attachments,
                    title: pois.join(', '),
                    id: 'supplier order mail ' + pois.join(','),
                    orders: group.orders
                  });
                }, this)).fail(_.bind(function () {
                  AlertView.prototype.open('', _.i18n('common.googleFromEmailError').replace('%s', from));
                }, this));
              }
            }, this));          
          }, this));
        }, this));
      } catch (err) {
        console.log(err);
      }
    },

    //--------------------------
    createSendInvoiceMail: function (models, endUserId) {
      var defer = $.Deferred();
      var methods = [];
      methods.push(this.checkCustomerAddress.bind(this));
      methods.push(this.checkVat.bind(this));
      methods.push(this.checkInvoice.bind(this));
      methods.push(this.checkPayment.bind(this));

      var customer = App.request('customers:entity:end-user-id', endUserId);
      customer.fetch().done(_.bind(function () {
        this.applyInvoiceCheckList(methods, models, customer).done(_.bind(function (paid) {
          this.createInvoice(models, customer, paid).done(_.bind(function () {
            defer.resolve();
          }, this));
          console.log('all promises resolved');
        }, this)).fail(_.bind(function () {
          defer.reject();
          console.log('some promises failed');
        }, this)).always(_.bind(function () {
          console.log('all promises completed');
        }, this));
        return defer.promise();
      }, this));

      return defer.promise();
    },

    applyInvoiceCheckList: function (methods, models, customer, result) {
      var defer = $.Deferred();

      if (!methods || methods.length === 0) {
        defer.resolve(result);
      } else {
        var promise = methods[0];

        promise(models, customer).done(_.bind(function (result) {
          methods.splice(0, 1);
          this.applyInvoiceCheckList(methods, models, customer, result).done(_.bind(function (result) {
            defer.resolve(result);
          }, this)).fail(_.bind(function () {
            defer.reject();
          }, this));
        }, this)).fail(_.bind(function () {defer.reject();}, this));
      }

      return defer.promise();
    },

    checkCustomerAddress: function(models, customer) {
      var defer = $.Deferred();

      if (!customer.get('addressL1') && !customer.get('city')) {
        AlertView.prototype.open(_.i18n('orders.create-invoice-title'), _.i18n('orders.invoice.address-missing'));
        defer.reject();
      } else
        defer.resolve();

      return defer.promise();
    },

    checkVat: function(models, customer) {
      var defer = $.Deferred();

      if (customer.get('vatNumber') && customer.get('vatNumber') !== '') {
        this.checkVatChecked(models, customer).done(_.bind(function () {
          defer.resolve();
        }, this)).fail(_.bind(function () {
          defer.reject();
        }, this));
      } else {
        ConfirmationView.prototype.open({
          text: _.i18n('vat.empty-vat'),
          onConfirm: _.bind(function () {defer.resolve();}, this),
          onCancel: _.bind(function () {defer.reject();}, this)
        });
      }

      return defer.promise();
    },

    checkVatChecked: function (models, customer) {
      var defer = $.Deferred();

      if (customer.get('vatNumberChecked') === true) {
        this.checkVatValid(models, customer).done(_.bind(function () {
          defer.resolve();
        }, this)).fail(_.bind(function () {
          defer.reject();
        }, this));
      } else {
        this.updateVatValid(models, customer).done(_.bind(function () {
          defer.resolve();
        }, this)).fail(_.bind(function () {
          defer.reject();
        }, this));
      }

      return defer.promise();
    },

    updateVatValid: function (models, customer) {
      var defer = $.Deferred();

      customer.checkVat().done(_.bind(function (valid) {
        if (!valid) {
          ConfirmationView.prototype.open({
            text: _.i18n('orders.vat.not-valid'),
            onConfirm: function () {defer.resolve();},
            onCancel: function () {defer.reject();}
          });
        } else {
          defer.resolve();
        }
      }, this)).fail(_.bind(function () {
        ConfirmationView.prototype.open({
          text: _.i18n('vat.checkVatError'),
          onConfirm: _.bind(function () {defer.resolve();}, this),
          onCancel: _.bind(function () {defer.reject();}, this)
        });
      }, this));

      return defer.promise();
    },

    checkVatValid: function (models, customer) {
      var defer = $.Deferred();

      if (customer.get('vatNumberValid') === true) {
        defer.resolve();
      } else {
        ConfirmationView.prototype.open({
          text: _.i18n('orders.vat.not-valid'),
          onConfirm: _.bind(function (){
            defer.resolve();
          }, this),
          onCancel: _.bind(function () {
            defer.reject();
          }, this)
        });
      }

      return defer.promise();
    },

    checkPayment: function (models) {
      var defer = $.Deferred();

      var notPaidOrders = [];
      _.each(models, function (model) {
        if (model.get('payedByCustomer') !== true)
          notPaidOrders.push(model);
      }, this);

      if (notPaidOrders.length > 0) {
        OrderConfirmationView.prototype.open(
          _.i18n('customer.confirmInvoiceNotPaid'),
          notPaidOrders,
          _.bind(function () {
            defer.resolve(false);
          }, this),
          _.bind(function () {
            defer.reject();
          }, this)
        );
      } else
        defer.resolve(true);

      return defer.promise();
    },

    checkInvoice: function (models) {
      var defer = $.Deferred();

      var hasInvoice = false;
      _.each(models, function (model) {
        if (model.get('toInvoice') === true)
          hasInvoice = true;
      }, this);

      if (!hasInvoice) {
        defer.resolve();
      } else {
        ConfirmationView.prototype.open({
          text: _.i18n('orders.orders-invoiced'),
          onConfirm: _.bind(function () {
            defer.resolve();
          }, this),
          onCancel: _.bind(function () {
            defer.reject();
          }, this)
        });
      }
      return defer.promise();
    },

    createInvoice: function (models, customer, paid) {
      var defer = $.Deferred();

      var pois = [];
      _.each(models, function (model) {
        pois.push(model.get('purchaseOrderId'));
      }, this);

      ProformatPreviewView.prototype.open({
        collection: new Backbone.Collection(models),
        onConfirm: _.bind(function () {
          if (Settings.configValue('orders.newInvoicePaymentTerms') === true) {
            NewInvoiceView.prototype.open({
              pois: pois,
              customer: customer,
              paid: paid,
              onConfirm: _.bind(function (invoice) {
                var model = App.request('endUserInvoice:model', invoice);
                this.sendInvoiceMail(customer, [model], paid);
                defer.resolve();
              }, this),
              onFail: _.bind(function () {
                AlertView.prototype.open('', 'VERIFY CUSTOMER DATA');
                defer.fail();
              }, this)
            });
          } else {
            App.request('order:generate-invoice', pois, null).done(_.bind(function (invoice) {
              defer.resolve();
              var model = App.request('endUserInvoice:model', invoice);
              this.sendInvoiceMail(customer, [model], paid);
            }, this)).fail(_.bind(function () {
              defer.fail();
            }, this));
          }
        }, this),
        onCancel: _.bind(function () {
          defer.fail();
        }, this)
      });

      return defer.promise();
    },

    sendInvoiceMail: function (customer, invoices, paid, callback) {
      var locale = customer.get('locales') || Settings.get('lang').toLowerCase();

      var attachments = [];
      var invoiceIds = [];
      var formatedInvoiceNumbers = [];
      var paymentDelay = -1;
      var firstName = customer.get('firstName') || '';

      _.each(invoices, _.bind(function (invoice) {
        attachments.push({
          url: Settings.url('dl', 'proforma', {invoiceSecId: invoice.get('secId'), lang: locale.toLowerCase()}),
          name: invoice.get('formatedInvoiceNumber') + '.pdf',
          'content-type': 'application/pdf'
        });

        invoiceIds.push(invoice.get('secId'));
        formatedInvoiceNumbers.push(invoice.get('formatedInvoiceNumber'));

        if(invoice.get('paymentDelay') !== -1)
          paymentDelay = invoice.get('paymentDelay');
      }, this));
     

      var contactEmail = customer.get('email') || customer.get('endUserId');
      var invoiceAddress = customer.get('invoiceEmail');
      var to = contactEmail;
      var cc = '';
      var bcc = '';         

      var status = null;
      _.each(Settings.configValue('mails.templates'), function (s) {
        if (s.template === 'MAIL_ORDER_INVOICE')
          status = s;
      }, this);

      if(status) {
        if (status.bcc)
          bcc = status.bcc;

        if (contactEmail && invoiceAddress) {
          to = customer.get('invoiceEmail');
          cc = contactEmail;
        }

        var from = this.getFrom(status.template, locale);      
        this.checkFrom(from).done(_.bind(function () {
          EmailView.prototype.open({
            from: from,
            to: to,
            cc: cc,
            bcc: bcc,
            allowFromSelection: status.allowFromSelection,           
            templateType: (paid ? 'MAIL_INVOICE' : 'MAIL_INVOICE_NOT_PAID'),    
            fetchTemplateData: _.bind(function () {
              var defer = $.Deferred();    
              defer.resolve({
                formatedInvoiceNumbers: formatedInvoiceNumbers.join(', '),
                paymentDelay: paymentDelay,
                firstName: firstName
              });
              return defer.promise();
            }, this), 
            templateLocale: locale,
            id: 'invoice.' + invoiceIds.join(','),
            title: _.i18n('common.invoiceEmail') + ' | ' + formatedInvoiceNumbers.join(', '),
            attachments: attachments,
            onMailSend: _.bind(function (mails) {
              var promises = [];
              _.each(invoices, function (invoice) {
                promises.push(App.request('order:invoice-sent', invoice.get('secId'), mails));               
              }, this);

              $.when.apply($, promises).done(_.bind(function () {
                if (callback)
                  callback();
              }, this));
            }, this)
          });
        }, this)).fail(_.bind(function () {
          AlertView.prototype.open('', _.i18n('common.googleFromEmailError').replace('%s', from));
        }, this));
      }
    }
  };
});

